export default (theme) => {
  const {
    primary,
    white,
    pink,
  } = theme.palette.common
  const { maxContentWidth, appBarHeight } = theme.global

  return {
    appBar: ({ hide }) => {
      const top = hide ? `-${appBarHeight.desktop}` : 0
      return {
        top,
        backgroundColor: white,
        height: appBarHeight.desktop,
        [theme.breakpoints.down('md')]: {
          height: appBarHeight.mobile,
        },
        transition: 'top 0.25s',
      }
    },

    toolbar: {
      margin: '0 auto',
      maxWidth: maxContentWidth,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    toolbarLeft: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },

    toolbarRight: {
      display: 'flex',
      alignItems: 'center',
    },

    navigationContainer: {
      height: '100%',
      marginLeft: '2.5rem',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        height: 'unset',
        marginLeft: 0,
      },
    },

    navigationLink: {
      height: '100%',
      boxSizing: 'content-box',
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: '2rem',
      color: pink,
      position: 'relative',
      '&:hover': {
        color: primary,
      },
      '&.active': {
        color: primary,
      },
      [theme.breakpoints.down('md')]: {
        margin: '1rem 0rem',
      },
    },

    navigationButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '1rem 0',
      [theme.breakpoints.down('md')]: {
        margin: '0',
      },
    },

    authButtons: {
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'start',
      },
    },

    button: {
      margin: '0 0.5rem',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        margin: '1.5rem 0 0 0',
      },
    },

    menuButton: {
      '& > button': {
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },

    underline: {
      position: 'absolute',
      bottom: 0,
      [theme.breakpoints.down('md')]: {
        bottom: '-0.5rem',
      },
    },

    languageContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '2rem',
      [theme.breakpoints.down('md')]: {
        marginRight: '1rem',
      },
    },

    languageText: {
      marginLeft: '0.2rem',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    sideDrawer: {
      justifyContent: 'space-between',
      margin: '0rem 1.5rem',
      alignItems: 'center',
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
      },
    },

    drawerContainer: {
      marginTop: appBarHeight.mobile,
      padding: '1rem 2em',
      width: '280px',
    },

    image: {
      [theme.breakpoints.down('md')]: {
        width: '5rem',
      },
    },

    imageContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  }
}
